// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { CALLBACK_STATUS } from '../../constants/callbackStatus';

export default class UrlCallbacksPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'callbackprocessorUrlCallbacks';
        this.Server = this.props.context.getState().server.callbackprocessorUrlCallbacks;
        this.MenuDisplayType = 'menu';
        // resourceUuid: every callback sent about one payin or payout.
        this.searchFields = ['uuid', 'url', 'resourceUuid'];
        this.disableGlobalEditor = true;
        this.disableAdd = true;

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'url', label: 'url', alignRight: false, cell: 'Url', displayGrid: true, disableEditor: true },
            // A merchant callback's transaction, and its place among the callbacks
            // sent about it. Empty on any other callback.
            {
                id: 'resourceKind',
                label: 'resourceKind',
                alignRight: false,
                cell: 'Items',
                items: ['payin', 'payout'],
                displayGrid: true,
                disableEditor: true
            },
            { id: 'resourceUuid', label: 'resourceUuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            { id: 'sequence', label: 'sequence', alignRight: true, cell: 'Number', blankWhenNull: true, displayGrid: true, disableEditor: true },
            { id: 'request', label: 'request', alignRight: false, cell: 'Json', displayGrid: true, disableEditor: true },
            { id: 'response', label: 'response', alignRight: false, cell: 'Json', displayGrid: true, disableEditor: true },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'State',
                items: CALLBACK_STATUS,
                displayGrid: true,
                disableEditor: true
            },
            { id: 'history', label: 'history', alignRight: false, cell: 'Json', displayGrid: false, disableEditor: true },
            { id: 'executionTime', label: 'executionTime', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'retriesRemaining', label: 'retriesRemaining', alignRight: true, cell: 'Number', displayGrid: true, disableEditor: true },
            { id: 'nextRetry', label: 'nextRetry', alignRight: false, cell: 'DateTime', displayGrid: true, disableEditor: true },
            { id: 'signature', label: 'signature', alignRight: false, cell: 'BigText', displayGrid: false, disableEditor: true },
            // BigText, not Json: these are the exact bytes sent and signed, which
            // the Json cell would re-serialize.
            { id: 'body', label: 'body', alignRight: false, cell: 'BigText', displayGrid: false, disableEditor: true },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
